/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';

interface IArgs {
  title: string;
  body: string;
}

interface UiProtectionEmptyStateSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

const UiProtectionEmptyStateComponent =
  templateOnly<UiProtectionEmptyStateSignature>();

export default UiProtectionEmptyStateComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Protection::EmptyState': typeof UiProtectionEmptyStateComponent;
  }
}
